/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { FC, useEffect, useRef, useState } from 'react';
import clsx from 'clsx';
import { omit } from 'lodash';

import { IRichTextGraphQL } from '../../models/Contentful/types/siteTemplateGraphQL';
import RichTextComponentGraphQL from '../RichTextComponentGraphQL';
import Typo from '../Typo';
import styles from './popover.module.sass';

export interface PopoverProps {
  children: React.ReactNode;
  className?: string;
  showPopoverOnOverflow?: boolean;
  childProps?: Omit<React.HTMLAttributes<HTMLSpanElement>, 'children'>;
  popCompClasses?: string;
  popoverComp?: React.ReactNode;
  isActionOnClick?: boolean;
  open?: boolean;
}

export interface PopoverCompProps {
  title?: string;
  subtitle?: IRichTextGraphQL;
}

export const PopoverComp = (props: PopoverCompProps) => {
  const { title, subtitle } = props;
  return (
    <span className="has-text-left is-block">
      {title && (
        <Typo normal classes="mb-1 is-block">
          {title}
        </Typo>
      )}
      {subtitle && (
        <Typo small light>
          {typeof subtitle === 'string' ? (
            subtitle
          ) : (
            <RichTextComponentGraphQL json={subtitle.json} links={subtitle?.links} />
          )}
        </Typo>
      )}
    </span>
  );
};

const Popover: FC<PopoverProps> = props => {
  const {
    children,
    className,
    popoverComp,
    childProps,
    isActionOnClick,
    popCompClasses,
    open,
    showPopoverOnOverflow = false,
  } = props;

  const textRef = useRef<HTMLDivElement>(null);
  const [isPopOverVisible, setIsPopOverVisible] = useState(true);

  useEffect(() => {
    if (
      textRef.current?.scrollWidth &&
      textRef.current?.clientWidth &&
      textRef.current?.scrollWidth > textRef.current?.clientWidth
    ) {
      setIsPopOverVisible(true);
    } else if (showPopoverOnOverflow) {
      setIsPopOverVisible(false);
    }
  }, [textRef, showPopoverOnOverflow]);

  return (
    <span
      className={clsx(styles.popInitiator, childProps?.className, {
        [styles.popHoverActions]: !isActionOnClick,
        [styles.popClickActions]: isActionOnClick && open,
      })}
      {...omit(childProps, 'className')}
    >
      {isPopOverVisible && (
        <div className={clsx(styles.popComp, popCompClasses)}>{popoverComp}</div>
      )}
      {className ? (
        <div className={className} ref={textRef}>
          {children}
        </div>
      ) : (
        children
      )}
    </span>
  );
};

export default Popover;
